export const lightTheme = {
  primaryTextColor: '#291F5E',
  secondaryTextColor: '#777777',
  backgroundColor: '#fff',
  secondaryBackgroundColor: '#F5F5F5',
  undelineColor: 'black',
};
